var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"paragraphs"},[_c('p',{staticClass:"font paragraphs__paragraph"},[_vm._v(_vm._s(_vm.paragraph))])])}
var staticRenderFns = []

export { render, staticRenderFns }